import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IframeTemp from '@/layout/components/iframe/IframeTemp';
export default {
  name: 'AppMain',
  components: {
    IframeTemp: IframeTemp
  },
  data: function data() {
    return {
      showBreadcrumb: true,
      include: ['preViewRule', 'editRule', 'system']
    };
  },
  created: function created() {
    var systemId = this.$store.state.settings.breadcrumb.systemId;
    if (systemId === 'LC_EBM' || systemId === 'LC_SIM' || systemId === 'LC_IE' || systemId === 'LC_FAQ') {
      this.showBreadcrumb = false;
    } else {
      this.showBreadcrumb = true;
    }
  },
  updated: function updated() {
    var systemId = this.$store.state.settings.breadcrumb.systemId;
    if (systemId === 'LC_EBM' || systemId === 'LC_SIM' || systemId === 'SIM' || systemId === 'LC_IE' || systemId === 'LC_FAQ') {
      this.showBreadcrumb = false;
    } else {
      this.showBreadcrumb = true;
    }
  },
  computed: {
    key: function key() {
      return this.$route.path;
    },
    showIframe: function showIframe() {
      var savediframeUrl = this.$route.query.src || this.$store.state.settings.iframeUrl;
      if (!savediframeUrl) return false;
      return savediframeUrl.includes('/iframe_'); // 有iframe_的路径显示iframe
    },
    breadcrumb: function breadcrumb() {
      var arr = this.$store.state.settings.breadcrumb.resourcePath.split('/');
      return arr;
    }
  },
  methods: {
    getPage: function getPage() {
      var item = this.$store.state.settings.breadcrumb.path;
      var systemId = this.$store.state.settings.breadcrumb.systemId;
      var url = item.split('#');
      this.showBreadcrumb = true;
      if (systemId === 'LC_PLATFORM') {
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: null
        });
        this.$router.push(url[1]);
      } else {
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: item
        });
      }
      if (systemId === 'LC_EBM' || url[1] === 'catalogue') {
        this.showBreadcrumb = false;
      }
    }
  }
};